export enum NotificationViewType {
    POPOVER = 0,
    FULLSCREEN = 1
}